import axios from "axios";
import { API_BASE_URL } from "./config";

// ============================================
// AXIOS: Global request interceptor
// ============================================
// Adds cache-busting and no-cache headers to every axios request
// so browsers never serve stale responses.
axios.interceptors.request.use((config) => {
  // Append a cache-busting timestamp query parameter
  const separator = config.url.includes("?") ? "&" : "?";
  config.url = `${config.url}${separator}_cb=${Date.now()}`;

  // Set no-cache headers
  config.headers["Cache-Control"] = "no-cache, no-store, must-revalidate";
  config.headers["Pragma"] = "no-cache";
  config.headers["Expires"] = "0";

  return config;
});

// ============================================
// FETCH: Global fetch override
// ============================================
// Wraps the native fetch so that requests to our API automatically
// get cache-busting. Non-API requests (images, blobs, etc.) are untouched.
const originalFetch = window.fetch;
window.fetch = function (input, init = {}) {
  const url = typeof input === "string" ? input : input?.url || "";

  // Only apply cache-busting to our own API
  if (url.startsWith(API_BASE_URL)) {
    // Append cache-busting timestamp
    const separator = url.includes("?") ? "&" : "?";
    const bustUrl = `${url}${separator}_cb=${Date.now()}`;

    // Merge no-cache headers + cache: 'no-store'
    const headers = new Headers(init.headers || {});
    headers.set("Cache-Control", "no-cache, no-store, must-revalidate");
    headers.set("Pragma", "no-cache");
    headers.set("Expires", "0");

    return originalFetch.call(this, bustUrl, {
      ...init,
      cache: "no-store",
      headers,
    });
  }

  // Non-API requests pass through untouched
  return originalFetch.call(this, input, init);
};
